import { getEmbedUrlForId } from './youtube'

interface Props {
  youtubeId: string
}
export function YoutubeIframe({ youtubeId }: Props) {
  const origin = typeof window === 'undefined' ? '' : window.location.origin

  return (
    <div className="faq-answer-youtube">
      <iframe
        src={getEmbedUrlForId(youtubeId, { rel: '0', origin })}
        title="YouTube video player"
        allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}
